import moment from 'moment';
import { React, useEffect, useState } from 'react';
import styled from 'styled-components';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';

const ValidMemberInfo = (props) => {
  const { data, onClick } = props;
  const { t, languageMode } = useLanguage();
  const { isDark } = useTheme();

  const [isExistNotReceived, setIsExistNotReceived] = useState(false);

  useEffect(() => {
    if (data.notReceivedPrice === 0 || data.notReceivedPrice === undefined) setIsExistNotReceived(false);
    else setIsExistNotReceived(true);
  }, [data])

  // 전화번호 뷰 정리 //
  function selectPhoneView() {
    if (!data.phone || data.phone === '') return t('validMember.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('validMember.noPhone');
  }

  return (
    <TopLevelWrapper onClick={onClick} $isDark={isDark}>
      <Table>
        <Body>
          <Tr style={{ width: '71px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '52px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.name}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '80px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '60px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.gender === 'male' ? t('validMember.male') : t('validMember.female')}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '112px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '98px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.birthDay, 'YYYYMMDD').format(t('validMember.birthFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '114px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '114px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{selectPhoneView()}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '242px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '218px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.viewMembershipName}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '98px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '90px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.viewStartDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '180px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '90px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{moment(data.viewEndDate).format(t('validMember.dateFormat'))}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          <Tr style={{ width: '24px' }}>
            <Td>
              <TextWrapper style={{ maxWidth: '24px' }}>
                <Text isExistNotReceived={isExistNotReceived}>{data.viewCount}</Text>
              </TextWrapper>
            </Td>
          </Tr>
          {
            moment(data.viewEndDate).diff(moment(), 'day') <= 5 &&
            <Tr style={{ width: '45px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '45px' }}>
                  <Dday>{moment(moment(data.viewEndDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') === 0 ? 'D-day' : 'D-' + moment(moment(data.viewEndDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day')}</Dday>
                </TextWrapper>
              </Td>
            </Tr>
          }
        </Body>
      </Table>
    </TopLevelWrapper>
  )
};

export default ValidMemberInfo;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 1018px;
  height: 50px;

  margin-top: 8px;

  border: 1px solid ${props => props.theme.subBackground};
  border-radius: 30px;
  background: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.primary};
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
  
  margin-left: 20px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  max-height: 20px;

  overflow: hidden;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isExistNotReceived ? props.theme.primary : props.theme.subText};
  
  margin: 0 0 0 0;
`;

const Dday = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 20px;

  border-radius: 30px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Regular;
  font-size: 11px;

  color: #FFFFFF;

  margin: 0 0 0 0;
`;
